import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { Link } from "react-router-dom";
import { Modal } from "@material-ui/core";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";

export const TrainingCourseWalkthrough = (props) => {
	const [isOpen, setIsOpen] = useState(true);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		serviceProvider.post("/home?type=setfirsttrainingseen", JSON.stringify({ uid: usid }), true).then((response) => {
			// console.log(response);
		});
	}, []);
	return (
		<>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/training-course">Training Courses</BreadcrumbsItem>
			<BreadcrumbsItem to="/training-courses/introduction-to-industry-40">Introduction to Industry 4.0</BreadcrumbsItem>
			<div className="course-wt-bg" style={{ background: `url(${require("../../assets/img/common-img/tc-waklthrough-bg.svg").default})` }}>
				<Modal open={isOpen} className="single-walkthrough-modal">
					<>
						<div className="single-wlakthrough-content">
							<Link to="/training-courses/introduction-to-industry-40" className="clsoe-btn">
								<img src={require("../../assets/img/common-img/close-icon-gray.svg").default} alt="X" />
							</Link>
							<div className="card">
								<div className="div-img">
									<img src={require("../../assets/img/common-img/tc-wlk-img.svg").default} alt="true" />
								</div>
								{/* div-img end */}
								<div className="div-txt">
									<div className="card-content">
										<h2 className="heading-h1">Your Training Course</h2>
										<p className="para-p">
											Check your overall and by section progress. Use the bottom menu to navigate between course info, Q&A and
											the Quiz.
										</p>
									</div>
									<div className="card-footer">
										<Link to="/training-courses/introduction-to-industry-40" className="btn-got-it">
											Got it
										</Link>
									</div>
								</div>
								{/* div-img end */}
							</div>
						</div>
					</>
				</Modal>
			</div>
		</>
	);
};
